import SECTION_NAMES from 'constants/sectionNames';
import { HOUSEHOLD_PATHS_TO_FIELD_NAMES_MAP } from 'pages/AffordaHousehold/constants';
import { WAGES_AND_INCOME_PATHS_TO_FIELD_NAMES_MAP } from 'pages/AffordaWagesAndIncome/constants.initialSteps';
import { ASSETS_PATHS_TO_FIELD_NAMES_MAP } from 'pages/AffordaAssets/constants';
import { IDENTIFYING_DETAILS_PATHS_TO_FIELD_NAMES_MAP } from 'pages/AffordaIdentifyingDetails/constants';
import { CREDIT_AND_CRIMINAL_CHECK_PATHS_TO_FIELD_NAMES_MAP } from 'pages/AffordaCreditAndCriminalCheck/constants';
import { SELF_IDENTIFICATION_PATHS_TO_FIELD_NAMES_MAP } from 'pages/AffordaSelfIdentification/constants';

const INITIAL_SECTION_STATE = {
  formState: {},
  formValues: {},
};

export const INITIAL_STATE = {
  id: null,
  portalUserId: null,
  applicantId: null,
  applicationId: null,
  householdId: null,
  createdAt: null,
  updatedAt: null,
  deletedAt: null,
  [SECTION_NAMES.WELCOME_AND_QUALIFY]: INITIAL_SECTION_STATE,
  [SECTION_NAMES.HOUSEHOLD]: INITIAL_SECTION_STATE,
  [SECTION_NAMES.WAGES_AND_INCOME]: INITIAL_SECTION_STATE,
  [SECTION_NAMES.ASSETS]: INITIAL_SECTION_STATE,
  [SECTION_NAMES.PAYMENTS]: INITIAL_SECTION_STATE,
  [SECTION_NAMES.IDENTIFYING_DETAILS]: INITIAL_SECTION_STATE,
  [SECTION_NAMES.CREDIT_CRIMINAL_CHECK]: INITIAL_SECTION_STATE,
  [SECTION_NAMES.SELF_IDENTIFICATION]: INITIAL_SECTION_STATE,
  [SECTION_NAMES.DOCUMENTS_AND_UPLOADS]: INITIAL_SECTION_STATE,
  [SECTION_NAMES.APPLICATION_SUBMISSION]: INITIAL_SECTION_STATE,
};

export const STEP_NAME_TO_SECTION_FIELD_NAME_MAP = {
  [SECTION_NAMES.HOUSEHOLD]: HOUSEHOLD_PATHS_TO_FIELD_NAMES_MAP,
  [SECTION_NAMES.WAGES_AND_INCOME]: WAGES_AND_INCOME_PATHS_TO_FIELD_NAMES_MAP,
  [SECTION_NAMES.ASSETS]: ASSETS_PATHS_TO_FIELD_NAMES_MAP,
  [SECTION_NAMES.IDENTIFYING_DETAILS]:
    IDENTIFYING_DETAILS_PATHS_TO_FIELD_NAMES_MAP,
  [SECTION_NAMES.CREDIT_AND_CRIMINAL]:
    CREDIT_AND_CRIMINAL_CHECK_PATHS_TO_FIELD_NAMES_MAP,
  [SECTION_NAMES.SELF_IDENTIFICATION]:
    SELF_IDENTIFICATION_PATHS_TO_FIELD_NAMES_MAP,
};
